import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import {
  CLIENT_ADMIN,
  ORG_ADMIN,
  RESTRICTED_SITE_ADMIN,
  SITE_ADMIN,
} from '../../../lib/utils/constants/UserTypes';
import Tooltip from '../../../shared/Tooltip';

export default function ChatButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { userType } = useSelector(state => state.currentUser);

  useEffect(() => {
    window.hsConversationsSettings = {
      loadImmediately: true,
      inlineEmbedSelector: '#hubspot-chat',
    };
  }, []);

  // by default we set the chatflow as the admin one (61303651)
  const setChatType = () => {
    switch (userType) {
      case CLIENT_ADMIN:
      case ORG_ADMIN:
      case RESTRICTED_SITE_ADMIN:
      case SITE_ADMIN:
        break;
      default:
        window.history.pushState({}, 'employee_chat', '?employee_chat=true');
        window.HubSpotConversations.widget.refresh();
    }
  };

  const openModal = () => {
    setIsOpen(true);
    setChatType();
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <IconWrapper
        onClick={() => (!isOpen ? openModal() : closeModal())}
        data-tip="Ask Us"
        data-for="HubspotButton"
      >
        <i className="fa-regular fa-question fa-xl"></i>
      </IconWrapper>
      <HubspotChat isOpen={isOpen}>
        <CloseButton mode="outline" variant="grey" onClick={() => closeModal()}>
          <i className="fa-regular fa-close"></i>
        </CloseButton>
        <div id="hubspot-chat"></div>
      </HubspotChat>
      <TooltipWrapper>
        <Tooltip id="HubspotButton" />
      </TooltipWrapper>
    </>
  );
}

const TooltipWrapper = styled.div`
  display: none;
  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
  }
`;

const CloseButton = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-weight: 800;
  font-size: 1.2em;
  margin-right: 4px;
  margin-bottom: 2px;
  &:hover {
    cursor: pointer;
    color: #fff;
  }
  i {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 4px;
    background: white;
    border: 1px solid #e3e8f0;
    border-radius: 16px;
    box-shadow: 0 2px 4px rgba(89, 72, 72, 0.08);
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    cursor: pointer;
  }
  i:hover {
    background: #52575c;
    color: #fff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const HubspotChat = styled.div`
  z-index: 9;
  position: fixed;
  bottom: 20px;
  right: 20px;
  visibility: hidden;

  ${props =>
    props.isOpen &&
    `
    visibility: visible;
  `}

  iframe#hubspot-conversations-inline-iframe {
    width: 320px;
    height: 500px;
    border-radius: 8px;
  }
`;

const IconWrapper = styled.div`
  flex: 1;
  text-align: end;
  margin-right: 20px;
  ${themeGet('mediaQueries.forMediumUp')} {
    flex: 0;
    display: block;
    cursor: pointer;
    margin: 0px 24px;
    &:hover {
      .fa-comment {
        color: ${themeGet('colors.black.60')};
      }
    }
  }
`;
